import { FC } from 'react';

import classNames from 'classnames';

interface NavigationSkeletonItemProps {
	size: 'long' | 'medium' | 'short' | 'long-full';
	isActive?: boolean;
}

export const NavigationSkeletonItem: FC<NavigationSkeletonItemProps> = ({
	size,
	isActive = false
}) => {
	return (
		<li className="disclosure-nav-item">
			<div className={classNames('main-link', { active: isActive })}>
				<div className={`skeleton-nav-item-${size}`} />
				{size === 'long' && <div className="skeleton-nav-disclosure-icon" />}
			</div>
		</li>
	);
};
